import {
  JobActivityRequestTouched,
  JobTypeActivityRequest,
} from "../types/jobs";

export const ACTIVITY_DEFAULTS: JobTypeActivityRequest = {
  name: "",
  description: "",
  active: true,
  forms: [],
  nextActivities: [],
  order: 0,
  jobStatus: {
    color: "#000000",
  },
};

export const ACTIVITY_TOUCHED_DEFAULTS: JobActivityRequestTouched = {
  nameTouched: false,
  orderTouched: false,
  jobStatusTouched: false,
};
